import { inject, Injectable, Signal, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";

import { Store } from "@ngrx/store";

import { AppError, AppMessage, IAppNotification } from "../models";
import { NotificationsActions } from "@core/state/notifications/notifications.actions";
import { NotificationsSelectors } from "@core/state/notifications/notifications.selectors";


@Injectable({ providedIn: 'root' })
export class NotificationFacade {

  private readonly _store: Store;

  public notifications: Signal<IAppNotification[]>;
  public errors: Signal<AppError[]>;
  public messages: Signal<AppMessage[]>;
  public shouldShowNotifications: Signal<boolean>;
  public total: Signal<number>;

  constructor() {
    this._store = inject(Store);
    
    this.notifications = toSignal(this._store.select(NotificationsSelectors.notifications), { initialValue: [] });
    this.shouldShowNotifications = toSignal(this._store.select(NotificationsSelectors.shouldShowNotifications), { initialValue: false });
    this.errors = toSignal(this._store.select(NotificationsSelectors.errors), { initialValue: [] });
    this.messages = toSignal(this._store.select(NotificationsSelectors.messages), { initialValue: [] });
    this.total = toSignal(this._store.select(NotificationsSelectors.total), { initialValue: 0 });
  }

  dispatchAddError(appError: AppError): void {
    this._store.dispatch(NotificationsActions.errorOccured({ error: appError }));
  }

  dispatchAddMessage(message: AppMessage): void {
    this._store.dispatch(NotificationsActions.messageOccured({ message: message }));
  }

  dispatchDismiss(id: string): void {
    this._store.dispatch(NotificationsActions.dismissed({ id: id }));
  }

  dispatchDismissAll(): void {
    this._store.dispatch(NotificationsActions.dismissAll());
  }

  toggleNotifications(): void {
    this._store.dispatch(NotificationsActions.toggle());
  }
}